import { render, staticRenderFns } from "./ServiceUnavailable.vue?vue&type=template&id=6b2b1c1d&"
import script from "./ServiceUnavailable.vue?vue&type=script&lang=js&"
export * from "./ServiceUnavailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports